export const status = {
  'INVALID_FREQUENCY': 'INVALID_FREQUENCY',
  'VALID_FREQUENCY': 'VALID_FREQUENCY',
  'READY': 'READY',
  'PLAYING': 'PLAYING',
  'NEED_MORE_PLAYERS': 'NEED_MORE_PLAYERS',
}